<template>
  <div class="boxitem">
    <header>
      <span class="fontSize16 orderStatus" :style="{ color: getColor }">{{
        orderStatusFormat
      }}</span>
      <span class="fontSize12" style="color: #999999"
        >{{ dataList.time }}<span class="lineSpan">|</span>订单号：{{
          dataList.orderCode
        }}</span
      >
      <span
        v-show="dataList.totalAmount > 0"
        class="fontSize12 orderAmount fontSize14"
        style="color: #999999; margin-left: 10px;"
        >订单金额：<span class="fontSize20 amoutWeight"
          >¥{{ dataList.totalAmount }}</span
        ></span
      >
    </header>
    <div class="pd-20 rowsItem">
      <el-row :gutter="20" class="rowItem" :class="{ 'rowItem--tall': dataList.orderShowText && orderShowTextDisplay.length > 20 }">
        <el-col :span="6" style="display: flex; align-items: center">
          <span><img class="baohanIcon" :src="getIconUrl()" /></span>
          <span class="pd-20 fontSize16 fw-800">{{
            dataList.guaranteeName
          }}</span>
        </el-col>
        <el-col :span="12" class="fontSize14 line" v-if="!showDetail">
          <div class="title">
            <div>投标项目名称：</div>
            <!-- <div class="ellipsis">{{ dataList.projectName }}</div> -->
            <el-tooltip
              class="item"
              effect="dark"
              :content="dataList.projectName"
              placement="top-start"
            >
              <div class="ellipsis">{{ dataList.projectName }}</div>
            </el-tooltip>
          </div>
          <div class="more-info" v-if="dataList.apiId !== 'ahyd' && dataList.apiId !== 'gzyh'">
            <div>被保人：</div>
            <el-tooltip
              class="item"
              effect="dark"
              :content="dataList.tenderCompanyName"
              placement="top-start"
            >
              <div class="ellipsis">{{ dataList.tenderCompanyName }}</div>
            </el-tooltip>
          </div>
          <div
            :class="{
              'more-info': true,
              'more-info-sig': dataList.apiId === 'ahyd' || dataList.apiId === 'gzyh',
            }"
          >
            <div>投标保证金金额(万元)：</div>
            <div class="ellipsis">
              {{ Number(dataList.guaranteeAmount) / 10000 }}
            </div>
          </div>
          <div class="order-show-text" v-if="dataList.orderShowText">{{ orderShowTextDisplay }}</div>
        </el-col>
        <el-col :span="12" class="projectInfo fontSize14 line" v-else>
          <div v-if="dataList.applyType === '7000'">
            保险额度（万元）：{{ dataList.guaranteeAmount }}
          </div>
          <div v-else-if="dataList.applyType === '9100'">
            履约保证金金额（万元）：{{ dataList.guaranteeAmount }}
          </div>
          <div v-else>
            投标保证金金额（万元）：{{ Number(dataList.guaranteeAmount) }}
          </div>
          <div>
            <span v-show="showService"
              >平台服务费（元）：{{ dataList.servicePrice }}</span
            >
            <span
              v-show="
                dataList.urgentServicePrice && dataList.applyType === '8000'
              "
              class="personInfo"
              >加急费（元）：{{ dataList.urgentServicePrice }}</span
            >
            <span
              v-show="dataList.totalAmount && dataList.applyType === '7000'"
              class="personInfo"
              >保险费（元）：{{ dataList.totalAmount }}</span
            >
          </div>
          <div class="order-show-text" v-if="dataList.orderShowText">{{ orderShowTextDisplay }}</div>
        </el-col>

        <el-col :span="6" class="btnItem">
          <div class="btns">
            <!--paymentType 支付方式 0-线上 1-线下-->
            <el-button
              type="primary"
              size="small"
              :loading="payLoading"
              v-if="formatStatusCode === 1000 && dataList.applyType !== '9100' && !isOtiPlat"
              @click="handlePay"
            >
              {{ isUploadTransfer ? '上传电汇底单' : '立即支付' }}
            </el-button>
            <el-button
              type="primary"
              size="small"
              v-if="!showDetail"
              plain
              @click="goOrderDetail"
              >订单详情</el-button
            >
            <el-button
              type="info"
              plain
              size="small"
              v-if="(formatStatusCode === -1 || formatStatusCode === 1000) && !isOtiPlat"
              @click="handleEdit('1')"
              >编辑保函</el-button
            >
            <el-button
              type="primary"
              size="small"
              v-if="formatStatusCode === 3000 && (!isOtiPlat|| isGxzxdb) && !isHlj && !isCqsw"
              @click="handleEdit('2')"
              >重新申请保函</el-button
            >
            <el-button
              type="primary"
              size="small"
              v-if="isHlj && ([-1, 500, 1000].includes(formatStatusCode))"
              plain
              @click="cancelOrder"
            >取消订单</el-button>

            <el-button
              type="primary"
              size="small"
              v-if="isHlj && ([2000, 4100, 5000].includes(formatStatusCode))"
              plain
              @click="refundOrder"
            >申请退保</el-button>

            <el-button slot="reference"
            @click="openDialog(dataList,1)"
            v-if="formatStatusCode === 5000 && (dataList.applyType === '7000'|| dataList.applyType === '8000') && dataList.isExectronic === '0' &&dataList.guaranteEexpressNumber"
              size="small">保函已邮寄</el-button>

            <el-button
              type="primary"
              size="small"
              plain
              @click="handleDownloadGuarantee"
              v-if="formatStatusCode === 5000 && (dataList.electronicGuaranteeFileId||dataList.guaranteeDownloadUrl)"
              >下载保函</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="applayInvoice"
              v-if="
                formatStatusCode === 5000 && dataList.invoiceStatus === '1000' && !isGxzxdb
              "
              >申请发票</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="invoiceHint"
              v-if="
                formatStatusCode === 5000 && dataList.invoiceStatus === '2000'
              "
              >开票中</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="downloadInvoice"
              v-else-if="dataList.electronUrl"
               plain
              >下载发票</el-button
            >

            <el-button slot="reference"
            @click="openDialog(dataList,2)"
            v-popover:popover-hover-2
            v-else-if="dataList.invoiceStatus === '3000' && dataList.issuanceMethod == '10'"
              size="small">发票已邮寄</el-button>
              <div  v-if="(formatStatusCode === -1 ||formatStatusCode === 4000) ">
                <el-button
              type="primary"
              size="small"
              @click="insuranceLetterCmmmit"
              v-if="dataList.applyType == '7000'"
              :loading="loadingCA"
              >上传投保单</el-button
            >
                <el-button
              type="primary"
              size="small"
              @click="handlePetition"
              v-else-if="dataList.applyType == '8000'"
              :loading="loadingCA"
              >签订申请书</el-button
            >
                <el-button
              type="primary"
              size="small"
              @click="handleCA"
              v-else
              :loading="loadingCA"
              >签订承诺书</el-button
            >
              </div>
            <el-button
              type="primary"
              size="small"
              v-if="(formatStatusCode !== 5000 || isGxzxdb) && isOtiPlat &&dataList.signatureResult"
              @click="goOtiUrl()"
              style="width:auto;margin-left: 0px;" 
              >{{formatStatusCode === 3000 && dataList.applicationChannelId == 41 ?'编辑保函':'跳转至'+dataList.channelPartnerShowName}}</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
<!-- 发票申请弹窗 -->
    <invoice-dialog
      ref="invoice"
      title="输入发票抬头"
      :disabled="disabled"
      :showInvoiceType="true"
      :isOtiPlat="isOtiPlat"
      @submit="onSubmit"
    ></invoice-dialog>
<!-- 发票邮寄信息弹窗 -->
<el-dialog
  title=""
  :visible.sync="dialogVisible"
  :close-on-click-modal="true"
  :showClose="false"
  width="30%">
  <span slot="title" class="dialog-footer">
    <el-descriptions :title="dialogTitle" class="margin-top" :column="1" border>
                  <el-descriptions-item>
                    <template slot="label"><i class="el-icon-user"></i>物流单号 </template>
                    {{expressNumber}}
                    <el-button type="info" class="copyButton" size="mini"  @click="copyText(expressNumber)" plain>复 制</el-button>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label" ><i class="el-icon-user"></i>物流公司名称 </template> {{expressCompanyName}}
                  </el-descriptions-item>

                  </el-descriptions></span>
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" size="small"  @click="dialogVisible = false">确 定</el-button>
  </span>
</el-dialog>
<!-- 意见弹窗 -->
<order-score-dialog
      ref="orderScoreDialog"
      :orderId="dataList.orderId"
      @submit="onOrderScoreSubmit"
></order-score-dialog>
  </div>
</template>

<script>
import invoiceDialog from './invoiceDialog'
import { cloneDeep, merge } from 'lodash'
import { ApplyType, GuaranteeApplyStatus, GuaranteeApplyStatusIns, GuaranteeApplyStatusElectBank,GuaranteeApplyStatusFirst} from '@/shared/type'
import { pay } from '@/shared/pay'
import { queryInvoiceByTaxNumber, createIssueInvoice, invoiceUrlDownload, cancelOrder, buildSecureUrl } from '@/api/order'
import { commitmentSign, querySysValueData } from '@/api/comm'
import { download,download1,downloadUrl } from '@/shared/file'
import { queryUserFeedbackByOrderId } from '@/api/user'
import orderScoreDialog from './orderScoreDialog'
export default {
  name: 'listCardItem',
  props: {
    dataList: {
      type: Object,
      default: () => ({}),
    },
    showDetail: {
      type: Boolean,
      default: false,
    },
  },
  components: { invoiceDialog,orderScoreDialog },
  computed: {
    showService() {
      return (
        this.dataList.servicePrice &&
        ['8000', '9600'].includes(this.dataList.applyType)
      )
    },
    orderStatus() {
      const status = this.dataList.guaranteeApplyStatus
      const applyType = this.dataList.applyType
      const copy = cloneDeep(applyType === '7000'? GuaranteeApplyStatusIns : applyType === '8000'?GuaranteeApplyStatusElectBank:applyType === '9100'?GuaranteeApplyStatusFirst: GuaranteeApplyStatus)
      const res = copy[status]
      return res
    },
    orderShowTextDisplay() {
      const text = this.dataList.orderShowText
      if (!text) return ''
      const parts = text.split('|')
      if (this.dataList.guaranteeApplyStatus === '3000') {
        return parts[1] || parts[0]
      }
      return parts[0]
    },
    orderStatusFormat() {
      return this.orderStatus?.n
    },
    getColor() {
      return this.orderStatus?.c
    },
    formatStatusCode() {
      return this.orderStatus?.k
    },
    isUploadTransfer() {
      // 线下支付判断条件:  电子担保保函并且支付方式-是基本户打款 || 银行保函 支付方式为线下支付 || 或者保险保函机构收费
      return (this.dataList.applyType === '9600' && this.dataList.basicPay === '1') || this.dataList.paymentType === '1' ||  (this.dataList.applyType === '7000' && this.dataList.payee === '2')
    },
    isOtiPlat(){
     return !!this.dataList.thridOrderNo
    },
    isHlj() {
      return this.$store.state.letter.isHlj
    },
    isCqsw() {
      return this.$store.state.letter.isCqsw
    },
    isGxzxdb(){
      return this.dataList.applicationChannelId == 42
    }
  },
    beforeMount() {
    querySysValueData({
      key: 'EXPRESS_TYPE'
    }).then(res => {
      this.options = res.data
    })
  },
  data() {
    return {
      fileList: [],
      disabled: false,
      payLoading: false,
      loadingCA: false,
      options: [],
      dialogVisible: false,
      dialogTitle:'',
      expressNumber:'',
      expressCompanyName:'',
      dialogTitles:{
        1: {n: '保函物流信息',},
        2: {n: '发票物流信息',},
      }
    }
  },
  methods: {
    openDialog(data,type) {
      this.dialogVisible = true
      this.dialogTitle = this.dialogTitles[type].n
      if(type === 1){
        this.expressNumber = data.guaranteEexpressNumber
        this.expressCompanyName = this.getExpressCompanyName(data.guaranteEexpressType)
      }else{
        this.expressNumber = data.expressNumber
        this.expressCompanyName = this.getExpressCompanyName(data.expressCompany)
      }
      },
    handleCA() {
      this.$router.push({
          path: '/letterCmmmit',
          query: {
            orderId: this.dataList.orderId,
            pdfID: this.dataList.electronicPdfFileId,
          },
        })
    },
    insuranceLetterCmmmit() {
        let data = {
              pdfID: this.dataList.commitmentPdfId,
              orderId: this.dataList.orderId,
              isNeedCommitment: false
            }
            this.$router.push({
              name: 'insuranceLetterCmmmit',
              query: {
                ...data,
              },
            })

    },
    handlePetition(){
      let data = {
        commitmentPdfId: this.dataList.commitmentPdfId,
              orderId: this.dataList.orderId,
              isBackHide: true,
            }
            this.$router.push({
              name: 'ElectronicBankPdfViewOk',
              query: {
                ...data,
              },
            })
    },


    handlePay() {
      if (this.isUploadTransfer) {
        // 线下支付
        return this.$router.push({
          path: '/wire-transfer',
          query: {
            order: this.dataList.orderId,
          },
        })
      }
      this.payLoading = true
      pay.call(this, this.dataList.orderId)
        .then((v) => {
          this.payLoading = false
        })
    },
    handleEdit(editType) {
      let type = this.dataList.applyType
      let path
      let isExectronic =  this.dataList.isExectronic
      if (isExectronic === '1' && type === '8000') {
        if(this.dataList.apiId === 'ahyd' || this.dataList.apiId === 'gzyh'){
          path = ApplyType[type][this.dataList.apiId]?.path
        }else{
          path = ApplyType[type].exectronicBank?.path
        }
      }else{
        path = ApplyType[type]?.path
      }
      let outerOrderNo = this.dataList.outerOrderNo
      const queryParm = {
          orderID: this.dataList.orderId,
          reapply: editType === '2'?true:false,//是否重新申请保函
          outerOrderNo: outerOrderNo
        }
      this.$router.push({
        path: path,
        query: queryParm,
      })
    },
    goOtiUrl(){
      if (this.isGxzxdb) {
        buildSecureUrl({
          url: this.dataList.signatureResult,
          orderId: this.dataList.orderId,
        }).then(res => {
          if (res.data) {
            window.open(res.data, "_blank");
          }
        })
      } else {
        window.open(this.dataList.signatureResult, "_blank");
      }
    },
    onSubmit(form) {
      return createIssueInvoice(
        merge({}, form, {
          orderId: this.dataList.orderId,
        })
      ).then((v) => {
        if (v.code === 200) {
          this.$message.success('提交成功')
          this.$refs.invoice.dialogVisible = false
          // TODO $emit
          location.reload()
        }
      })
    },
    onOrderScoreSubmit() {
      this.openInvoiceDialog()
    },
    getIconUrl() {
      return ApplyType[this.dataList.applyType]?.u
    },
    goOrderDetail() {
      this.$router.push({
        path: '/orderDetail',
        query: {
          order: this.dataList.orderId,
        },
      })
    },
    applayInvoice() {
      //判断有没有填写意见
      queryUserFeedbackByOrderId({orderId: this.dataList.orderId}).then((res) => {
        if (res.data) {
          this.openInvoiceDialog()
        }else{
          this.$refs.orderScoreDialog.open()
        }
      })
    },
    async openInvoiceDialog() {
      const { taxNumberElectron, bidderCompanyName} = this.dataList
      if (taxNumberElectron) {
        const { data } = await queryInvoiceByTaxNumber({
          taxNumber: taxNumberElectron,
        })
        this.source = data
        if (this.source && this.source.taxNumber) {
          this.disabled = true
          this.$refs.invoice.init(this.source)
          this.$refs.invoice.dialogVisible = true
          return
        }
      }
      this.$refs.invoice.init({'invoiceTitle':bidderCompanyName})
      this.$refs.invoice.dialogVisible = true
    },
    downloadInvoice() {
      const downMode = this.dataList.downMode
      if(this.isOtiPlat){
        downloadUrl({url: this.dataList.electronUrl},  this.dataList.orderCode+'_发票文件'+this.getFileExtension(this.dataList.electronUrl))
      }else if(downMode === '1'){
        const electronUrls = this.dataList.electronUrls
        const orderId = this.dataList.orderId
        const urls = electronUrls.split(",");
        urls.forEach(function(url,index){
          invoiceUrlDownload({ orderId: orderId, iex: index, }, orderId+'_'+index+'.pdf')
        })
      }else{
        download1(this.dataList.electronUrl)
      }
    },
    getFileExtension(url) {
      const lastDotIndex = url.lastIndexOf('.')
      const lastSlashIndex = url.lastIndexOf('/')
      if (lastDotIndex > lastSlashIndex && lastDotIndex < url.length - 1) {
        return url.substring(lastDotIndex);
      }
      return '.pdf'
    },
    handleDownloadGuarantee() {
      if(this.dataList.electronicGuaranteeFileId){
        download(this.dataList.electronicGuaranteeFileId)
      } else {
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
          })
        downloadUrl({url: this.dataList.guaranteeDownloadUrl},  this.dataList.orderCode+'_保函文件'+this.getFileExtension(this.dataList.guaranteeDownloadUrl))
        loading.close()
      }
    },
    getExpressCompanyName(value){
       const et = this.options.find(item => item.valuesetKey === value)
       value = et ? et.valuesetValue : value
       return value;
    },
    copyText(val){
      if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard 向剪贴板写文本
        this.$message.success('复制成功')
        return navigator.clipboard.writeText(val)
      } else {
		//创建一个input框
    let input = document.createElement('input');
      //设置id
      input.id = "temp_copy";
      //设置只读
      input.setAttribute('readonly', 'readonly');
      //赋值
      input.setAttribute('value', val);
      //把input添加到body中
      document.body.appendChild(input);
      //选中input框，取值复制
      $('#temp_copy').select();
      document.execCommand("copy",false,null);
      //删除input框
      document.body.removeChild(input);
      this.$message.success('复制成功')
      }
    },
    invoiceHint(){
      this.$message.info('发票将在申请后7个工作日内开出')
    },
    cancelOrder() {
      this.$confirm('是否确认取消此订单?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确认',
        type: 'warning'
      }).then(() => {
        cancelOrder(this.dataList.orderId).then(res => {
          if (res.success) {
            location.reload()
          }
        })
      })
    },
    refundOrder() {
      this.$alert('如需退保请联系客服4006166620转3，进行人工处理')
    }
  },
}
</script>

<style scoped lang="less">
.ellipsis {
  flex: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-left: 10px;
}
.title {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 20px;
}
.more-info {
  display: inline-flex;
  align-items: center;
  width: 40%;
  vertical-align: middle;
}
.more-info + .more-info {
  width: calc(60% - 10px);
  margin-left: 10px;
}
.more-info-sig {
  width: 100%;
}
.line {
  border-left: 1px solid #dbdbdb;
  border-right: 1px solid #dbdbdb;
  padding: 0 5% !important;
}

.boxitem header {
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  background-color: #eff6fa;
}
.baohanIcon {
  width: 66px;
  height: 66px;
}
.orderStatus {
  margin-right: 30px;
  font-weight: 800;
}
.boxitem {
  background-color: #ffffff;
  /*height: 160px;*/
}
.orderAmount {
  display: inline-block;
}
.amoutWeight {
  color: #eb3941;
  font-weight: 700;
}
.lineSpan {
  padding: 20px;
}
.projectInfo {
  display: flex;
  align-items: center;
  border-left: 1px solid #dbdbdb;
  border-right: 1px solid #dbdbdb;
  padding: 2% 5% !important;
}
/deep/ .btns .el-button:nth-of-type(odd) {
  margin-left: 0 !important;
}
/deep/ .btns .el-button {
  margin-bottom: 10px;
  width: 47%;
}
/deep/ .btns .halfWidth {
  width: 47%;
  display: inline-block;
  margin-left: 10px;
  /*padding: 6px 10px!important;*/
}
/deep/ .upload-demo .el-button {
  width: 100%;
}
/deep/ .btns .el-button span {
  font-size: 12px !important;
}
.btns {
  /*padding-left: 15%;*/
  position: absolute;
  /*right: 10%;*/
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}
.personInfo {
  margin-left: 40px;
}
.rowItem {
  height: 110px;
}
.rowItem--tall {
  height: 150px;
}
.rowItem .el-col {
  height: 100%;
}
.btnItem {
  position: relative;
}
.copyButton {
  padding: 3px 6px;
}
.order-show-text {
  color: red;
  width: 100%;
  white-space: normal;
  margin-top: 4px;
}
</style>